/* Lupin Gold sign-up credit, issued on submit (12/10/2026, Goldie). On the live theme since
   12/10/2026 as assets/lg-signup-credit.js, loaded from layout/theme.liquid. It calls the app
   route /apps/wholesale/signup-credit (code/src/handlers/signupProxy.js).

   What it does: the moment someone signs up, it asks the app for the $10, so the credit is in their
   account a second or two later instead of when Klaviyo's webhook runs (0 to 7 minutes). No secret
   in here: Shopify signs the request on its way through /apps/wholesale. The Klaviyo flow webhook
   stays exactly as it is and covers anyone this call misses (ad blocker, closed tab, daily cap).

   Two hooks:
   1. Klaviyo popup: listens for the klaviyoForms submit event (the hook lg-referral.js uses).
      Only the forms in FORMS, so a future newsletter-only form does not hand out credit.
   2. /pages/credit theme form: call  window.lgSignupCredit(email, firstName)  in the success
      branch of the Klaviyo subscribe call. It returns a promise.

   Both resolve to {status: "issued", amount: "10.00", expires: "2026-11-11"} when this call put the
   credit in, {status: "ok"} for anything else (already has it, has ordered before, limit reached),
   or null if the call failed. The same detail is sent as a window event, "lg:signup-credit", for
   whatever shows the success message or sends them to log in (not built here). Say "your $10 is in
   your account" only on "issued"; on anything else keep it to "check your email". */
(function () {
  try {
    var ROUTE = '/apps/wholesale/signup-credit';
    var FORMS = ['WSv854']; // the credit popup
    var asked = {};

    window.lgSignupCredit = function (email, firstName) {
      email = String(email || '').trim().toLowerCase();
      if (!email || email.indexOf('@') < 1) return Promise.resolve(null);
      if (asked[email]) return asked[email]; // one call per address per page view
      var body = { email: email };
      if (firstName) body.first_name = String(firstName).slice(0, 60);
      asked[email] = fetch(ROUTE, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
        keepalive: true // still sent if the page moves on (popup closing, redirect to login)
      }).then(function (res) {
        return res.ok ? res.json() : null;
      }).catch(function () {
        return null;
      }).then(function (result) {
        try {
          window.dispatchEvent(new CustomEvent('lg:signup-credit', { detail: { email: email, result: result } }));
        } catch (e) { /* old browser: the promise still resolves */ }
        return result;
      });
      return asked[email];
    };

    window.addEventListener('klaviyoForms', function (e) {
      var d = e.detail;
      if (!d || d.type !== 'submit' || FORMS.indexOf(d.formId) === -1) return;
      var m = d.metaData || {};
      if (m.$email) window.lgSignupCredit(m.$email, m.$first_name);
    });
  } catch (e) { /* never break the page */ }
})();
